var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlreadyExistUsers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 124,
    height: 121,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--neutral-background-base)",
    d: "M62.007 66.008c16.602 0 30.06-13.459 30.06-30.06 0-16.603-13.458-30.061-30.06-30.061-16.602 0-30.06 13.458-30.06 30.06 0 16.602 13.458 30.06 30.06 30.06Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--neutral-background-base)",
    d: "M92.067 35.947a30.064 30.064 0 1 1-60.128.007 30.064 30.064 0 0 1 60.128-.007Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--neutral-background-medium)",
    d: "M24.377 119.21c12.896 0 23.35-10.454 23.35-23.35s-10.454-23.35-23.35-23.35-23.35 10.454-23.35 23.35 10.454 23.35 23.35 23.35ZM99.613 119.21c12.896 0 23.35-10.454 23.35-23.35s-10.454-23.35-23.35-23.35c-12.895 0-23.35 10.454-23.35 23.35s10.454 23.35 23.35 23.35Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#7F8692",
    d: "M24.393 120.253A24.42 24.42 0 0 1 0 95.859a24.393 24.393 0 1 1 24.393 24.394ZM2.087 95.859a22.306 22.306 0 1 0 22.306-22.295 22.33 22.33 0 0 0-22.306 22.31v-.015ZM99.607 120.253a24.398 24.398 0 0 1-17.255-41.648 24.397 24.397 0 0 1 41.649 17.254 24.426 24.426 0 0 1-24.394 24.394Zm0-46.69a22.31 22.31 0 1 0 22.306 22.31 22.33 22.33 0 0 0-22.306-22.31Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--neutral-border)",
    d: "M88.69 107.479v-6.78a7.268 7.268 0 0 1 7.27-7.267h7.272a7.265 7.265 0 0 1 7.267 7.267v6.766l-21.809.014Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--neutral-background-base)",
    d: "M99.601 93.445a5.566 5.566 0 0 1-5.566-5.566v-1.294a5.58 5.58 0 0 1 11.16 0v1.294a5.575 5.575 0 0 1-1.64 3.946 5.573 5.573 0 0 1-3.954 1.62Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#7F8692",
    d: "M99.606 94.489a6.63 6.63 0 0 1-6.61-6.61v-1.294a6.623 6.623 0 0 1 13.248 0v1.294a6.634 6.634 0 0 1-6.638 6.61Zm0-12.455a4.543 4.543 0 0 0-4.522 4.523v1.294a4.537 4.537 0 0 0 9.072 0v-1.294a4.54 4.54 0 0 0-4.55-4.523Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M91.954 107.479v-6.534a.854.854 0 0 1 .839.696l1.2 5.848-2.039-.01Z",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M107.202 107.479v-6.534a.86.86 0 0 0-.839.696l-1.193 5.838h2.032Z",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#7F8692",
    d: "M111.555 108.523H87.659v-7.824a8.322 8.322 0 0 1 8.314-8.311h7.271a8.317 8.317 0 0 1 8.311 8.311v7.824Zm-21.809-2.088h19.722v-5.736a6.23 6.23 0 0 0-6.224-6.224h-7.27a6.23 6.23 0 0 0-6.228 6.224v5.736Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--neutral-border)",
    d: "M13.506 107.479v-6.78a7.268 7.268 0 0 1 7.267-7.267h7.27a7.267 7.267 0 0 1 7.268 7.267v6.766l-21.805.014Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--neutral-background-base)",
    d: "M24.407 93.445a5.566 5.566 0 0 1-5.566-5.566v-1.294a5.58 5.58 0 0 1 11.16 0v1.294a5.564 5.564 0 0 1-5.594 5.566Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#7F8692",
    d: "M24.372 94.489a6.63 6.63 0 0 1-6.61-6.61v-1.294a6.624 6.624 0 0 1 13.248 0v1.294a6.63 6.63 0 0 1-6.638 6.61Zm0-12.455a4.543 4.543 0 0 0-4.523 4.523v1.294a4.536 4.536 0 1 0 9.073 0v-1.294a4.543 4.543 0 0 0-4.55-4.523Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M16.737 107.479v-6.534a.862.862 0 0 1 .841.696l1.197 5.848-2.038-.01Z",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M32.011 107.479v-6.534a.862.862 0 0 0-.842.696l-1.196 5.848 2.038-.01Z",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#7F8692",
    d: "M36.32 108.523H12.426v-7.824a8.318 8.318 0 0 1 8.31-8.311h7.271a8.317 8.317 0 0 1 8.311 8.311v7.824Zm-21.806-2.088h19.718v-5.736a6.227 6.227 0 0 0-6.224-6.224h-7.27a6.227 6.227 0 0 0-6.224 6.224v5.736Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--neutral-border)",
    d: "M47.737 51.066V42.22a9.5 9.5 0 0 1 9.5-9.5h9.508a9.5 9.5 0 0 1 9.5 9.5v8.847H47.738Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--neutral-background-base)",
    d: "M62.007 32.72a7.305 7.305 0 0 1-7.306-7.306v-1.691a7.306 7.306 0 0 1 14.59 0v1.69a7.306 7.306 0 0 1-7.284 7.306Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#7F8692",
    d: "M62 33.762a8.349 8.349 0 0 1-8.35-8.35v-1.69a8.35 8.35 0 0 1 16.678 0v1.69a8.349 8.349 0 0 1-8.329 8.35Zm0-16.281a6.262 6.262 0 0 0-6.263 6.262v1.69a6.262 6.262 0 0 0 12.503 0v-1.69A6.262 6.262 0 0 0 62 17.48Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M52.013 51.066v-8.54a1.124 1.124 0 0 1 1.1.897l1.565 7.653-2.665-.01Z",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M71.934 51.066v-8.54a1.124 1.124 0 0 0-1.1.897l-1.565 7.653 2.665-.01Z",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#7F8692",
    d: "M77.308 52.11H46.695v-9.89a10.559 10.559 0 0 1 10.544-10.545h9.508A10.555 10.555 0 0 1 77.29 42.219l.017 9.89Zm-28.526-2.088H75.22V42.22a8.468 8.468 0 0 0-8.457-8.457h-9.508A8.468 8.468 0 0 0 48.8 42.22l-.017 7.803ZM63.054 96.903H52.976v-2.087h7.99v-23.43h2.088v25.517Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#7F8692",
    d: "M71.413 96.903H60.966V71.386h2.087v23.43h8.36v2.087ZM26.951 6.713l1.476-1.476 5.003 5.003-1.476 1.476-5.003-5.003ZM21.91 15.763h7.075v2.087H21.91v-2.087ZM37.074 0h2.087v7.076h-2.087V0Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M91.808 31.984c-13.31 1.68-23.367-11.616-18.371-23.847a30.085 30.085 0 0 1 18.371 23.847Z",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#7F8692",
    d: "M62.022 67.051a31.104 31.104 0 1 1 31.104-31.104 31.139 31.139 0 0 1-31.104 31.104Zm0-60.12a29.017 29.017 0 1 0 29.017 29.016A29.052 29.052 0 0 0 62.022 6.93Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D6E8D",
    d: "M89.564 26.244c6.376 0 11.546-5.17 11.546-11.546 0-6.377-5.17-11.547-11.546-11.547-6.377 0-11.547 5.17-11.547 11.547 0 6.376 5.17 11.546 11.547 11.546Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M89.564 26.244c6.376 0 11.546-5.17 11.546-11.546 0-6.377-5.17-11.547-11.546-11.547-6.377 0-11.547 5.17-11.547 11.547 0 6.376 5.17 11.546 11.547 11.546Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--neutral-background-base)",
    d: "m87.755 19.92-4.4-4.4 1.516-1.517 2.885 2.887 6.498-6.498 1.517 1.516-8.016 8.012Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 92.977,
    x2: 92.977,
    y1: 107.809,
    y2: 99.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9AFC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4D8E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 106.182,
    x2: 106.182,
    y1: 107.809,
    y2: 99.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9AFC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4D8E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 17.756,
    x2: 17.756,
    y1: 107.809,
    y2: 99.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9AFC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4D8E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 30.992,
    x2: 30.992,
    y1: 107.809,
    y2: 99.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9AFC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4D8E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 53.346,
    x2: 53.346,
    y1: 51.501,
    y2: 40.066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9AFC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4D8E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 70.602,
    x2: 70.602,
    y1: 51.501,
    y2: 40.066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9AFC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4D8E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 72.132,
    x2: 91.808,
    y1: 20.132,
    y2: 20.132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACFDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF0F1"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "h",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_11386_10747",
    transform: "matrix(.0016 0 0 .0016 -.167 0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlreadyExistUsers);
export default __webpack_public_path__ + "static/media/already-exist-users.40213823ef57e0d2af51e3b1711b0565.svg";
export { ForwardRef as ReactComponent };